import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Clock } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-deep-berry text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* About */}
          <div>
            <h3 className="font-display text-xl mb-4 text-white">Preserves of Cape Cod</h3>
            <p className="text-sm leading-relaxed opacity-90">
              Selling high quality Massachusetts made jams, jellies, and preserves. All products are made using our unique small batch process.
            </p>
          </div>

          {/* Location & Hours */}
          <div>
            <h3 className="font-display text-xl mb-4 text-white">Visit Us</h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                <div>
                  45 Seth Goodspeed Way<br />
                  Osterville, MA 02655
                </div>
              </div>
              <div className="flex items-start space-x-2">
                <Mail className="w-4 h-4 mt-1 flex-shrink-0" />
                <a href="mailto:contactus@preservesofcapecod.com" className="hover:text-gold transition-colors">
                  contactus@preservesofcapecod.com
                </a>
              </div>
              <div className="flex items-start space-x-2">
                <Clock className="w-4 h-4 mt-1 flex-shrink-0" />
                <div>
                  Mon-Fri: 9:00 AM - 5:00 PM<br />
                  Sat-Sun: Closed
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-display text-xl mb-4 text-white">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/shop" className="hover:text-gold transition-colors">
                  Shop All Products
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-gold transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-gold transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/wholesale/login" className="hover:text-gold transition-colors">
                  Wholesale Portal
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 mt-12 pt-8 text-center text-sm opacity-75">
          <p>© {new Date().getFullYear()} Preserves of Cape Cod. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
